<template>
  <div>
    <div v-for="page in pages" :key="page" style="padding: 4px;">
      <div class="tab_company_out">
        <h3>上海齐申复合材料</h3>
        <div class='dan'>出库单
          <span>No. {{ tableData.soNo }}</span>
        </div>
        <div class="tline">
          <span>收货方: {{tableData.customer_name}}</span>
          <time>日期: {{tableData.date}}</time>
        </div>
        <v-layout>
          <v-flex style="text-align:left;">收货地址: {{tableData.customer_address}}</v-flex>
          <v-flex>收货联系人: {{tableData.customer_contact}}</v-flex>
          <v-flex style="text-align:right;">电话: {{tableData.customer_phone}}</v-flex>
        </v-layout>
        <table cellpadding='0' cellspacing='0'>
          <tr>
            <th width='5%'>序号</th>
            <th width='25%'>品名及规格</th>
            <th width='10%'>单位</th>
            <th width='10%'>数量</th>
            <th width='20%'>批次号</th>
            <th width='30%'>备注</th>
          </tr>
          <tr v-for="(row, index) in tableData.items.slice((page-1)*onePageRow, page*onePageRow)" :key="index">
            <td>{{row.no}}</td>
            <td>{{row.name}}</td>
            <td>{{row.unit}}</td>
            <td>{{row.weight}}</td>
            <td>{{row.batch_no}}</td>
            <td>{{row.note}}</td>
          </tr>
          <template v-if="blankLines && tableData.items.slice((page-1)*onePageRow, page*onePageRow).length < onePageRow">
            <tr v-for="(_,index) in (onePageRow - tableData.items.slice((page-1)*onePageRow, page*onePageRow).length)" :key="index+10000">
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
              <td></td>
            </tr>
          </template>
        </table>
        <v-layout>
          <v-flex>收货方确认人:</v-flex>
          <v-flex>物流方经手人:</v-flex>
          <v-flex>送货方经手人:</v-flex>
        </v-layout>
        <v-layout style="height:20px;">

        </v-layout>
        <v-layout>
          <v-flex>第一联(白色)：存根联</v-flex>
          <v-flex>第二联(红色)：回单联</v-flex>
          <v-flex>第三联(蓝色)：客户联</v-flex>
          <v-flex>第四联(黄色)：物流存根联</v-flex>
        </v-layout>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StockOut',
  props: {
    // 接受的打印数据
    tableData: {
      type: Object,
      default () {
        return {
          soNo: '1234',
          customer_name: '',
          customer_address: '',
          customer_contact: '',
          customer_phone: '',
          date: '',
          items: []
        }
      }
    },
    // 每页多少行
    onePageRow: {
      type: Number,
      default: 6
    },
    // 是否插入空白行
    blankLines: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    pages () {
      // 求当前数据能打印的页数
      var pages_ = Math.ceil(this.tableData.items.length / this.onePageRow) // 向上取整数
      return pages_ <= 0 ? 1 : pages_
    }
  },
  methods: {
  }
}
</script>

<style scoped>
* {
    padding: 0;
    margin: 0;
    list-style-type: none;
    font-family: "微软雅黑";
    font-size: 12px;
}
.tab_company_out {
    text-align: center;
    width: 100%;
    margin: auto;
    page-break-after: always;
}
h3 {
    font-size: 14px;
}
.dan {
    text-align: center;
    position: relative;
}
.dan span {
    position: absolute;
    right: 0;
}
.tline {
    overflow: hidden;
}
.tline span {
    float: left;
}
.tline span ins {
    text-decoration: underline;
}
.tline time {
    float: right;
}
table {
    width: 100%;
    border: none;
    border-bottom: 1px solid #000;
}
table tr td {
    border: 1px solid #000;
    border-bottom: none;
    border-right: none;
    height: 20px;
    line-height: 20px;
    text-align: center;
}
table tr td:last-of-type,
table tr th:last-of-type {
    border-right: 1px solid #000;
}
table tr th {
    border-top: 1px solid #000;
    border-left: 1px solid #000;
    height: 22px;
    line-height: 22px;
    font-size: 12px;
}
table tr th:nth-child(2) {
    width: 0;
}
.lu {
    display: inline-block;
    padding-top: 10px;
}
.lu li {
    float: left;
    text-align: left;
    margin-right: 15px;
}
.lu li label {
    width: 100px;
    display: inline-block;
}
.lu li:last-of-type {
    margin-right: 0;
}
</style>
